import React, { useState, useRef, useMemo } from 'react';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import { Col, FloatingLabel, Form, Row, Stack, Ratio } from 'react-bootstrap';
import { Button, Icon } from 'lb-components';
import { CloseDark, CloseLight } from 'lb-components/src/stories/assets/icons';
import { Resend } from 'lb-components/src/stories/assets/icons/payment';

import classes from './Card.module.scss';
import _ from 'lodash';
import { Loader } from '../Loader';

const withdrawFee = 6;
const calcWithdrawFee = 0.06
const Card = ({
  id,
  platform,
  provider,
  logo,
  color,
  date,
  digits = [],
  submit,
  onDelete,
  actionType,
  balance,
  t,
  ...props
}) => {
  const actionFormRef = useRef();
  const deleteFormRef = useRef();
  const resendTimeoutRef = useRef();
  const oneTimeCodeRef = useRef();
  const [actionState, setActionState] = useState({
    show: true,
    confirm: false,
    resend: false,
    data: {
      amount: '',
      sms: '',
    },
    error: {
      sms: '',
      amount: '',
    },
  });
  const [deleteState, setDeleteState] = useState({
    show: false,
    error: '',
    resend: false,
  });
  const [loader, setLoader] = useState(false);
  const deleteHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isNaN(parseFloat(e.target.sms?.value))) {
      setDeleteState({
        ...deleteState,
        error: t('ბარათის წასაშლელად მიუთითეთ სმს კოდი'),
      });
    } else {
      onDelete({
        action: 'delete',
        cardId: id,
        provider: provider,
        sms: e.target.sms?.value,
        callback: (state) => {
          setDeleteState({ ...state });

          /* show: true,
             confirm: false,
             error: {},
           data: {},*/
        },
      });
    }
  };
  const submitHandler = (event) => {
    event.preventDefault();
    event.stopPropagation();
    let amount = parseFloat(actionState.data.amount);
    if(actionType === 'withdraw') {
      amount = (parseFloat(actionState.data.amount) / (1 - calcWithdrawFee)).toFixed(2);
    }
    let sms = parseInt(actionState.data.sms);
    if (!actionState.confirm) {
      //validate amount
      if (isNaN(amount)) {
        setActionState({
          ...actionState,
          error: { amount: t('თანხა არასწორად არის მითითებული') },
        });
      } else {
        if (actionType === 'deposit') {
          if (amount >= 1 && amount <= 50000) {
            submit(
              {
                cardId: id,
                amount: amount,
                sms: sms,
                provider: provider,
                loader: setLoader,
              },
              (callback) => {}
            );
            setActionState({
              ...actionState,
              confirm: false,
              error: {},
            });
          } else {
            setActionState({
              ...actionState,
              confirm: false,
              data: { amount: amount },
              error: {
                amount: t('შემოტანის ლიმიტები'),
              },
            });
          }
        } else {
          submit(
            {
              cardId: id,
              amount: amount,
              sms: sms,
              provider: provider,
              confirm: actionState.confirm,
              loader: setLoader,
            },
            ({ left, ...callback }) => {

              if (left) {
                clearTimeout(resendTimeoutRef.current);
                resendTimeoutRef.current = setTimeout(
                  () =>
                    setActionState((prevState) => ({
                      ...prevState,
                      resend: true,
                    })),
                  left * 1000
                );
              }
              setActionState({
                ...actionState,
                ...callback,
              });
            }
          );
        }
      }
    } else {
      //validate sms
      if (isNaN(parseFloat(event.target.sms?.value))) {
        setActionState({
          ...actionState,
          error: { sms: t('INVALID_SMS') },
        });
      } else {
        submit(
          {
            cardId: id,
            amount: amount,
            sms: sms,
            provider: provider,
            loader: setLoader,
          },
          (callback) => {
            const { sms, ...rest } = callback;
            const newState = {
              ...actionState,
              ...rest,
            };
            if (sms) newState.error.sms = sms;
            setActionState(newState);
          }
        );
      }
    }
  };
  const hotMoney = (m) => {
    if (m > 50000) m = 50000;

    if (m < 10)
      return [
        { key: '2', value: 2 },
        { key: '5', value: 5 },
        { key: '10', value: 10 },
      ];

    const r = Math.pow(10, parseInt(m).toString().length - 1);
    const n = Math.trunc(m / r) * r;
    const arr = [0.2, 0.5, 1];
    const res = [];

    for (let el of arr) {
      let amount = Math.round(el * n);
      res.push({ key: amount.toString(), value: amount });
    }
    return res;
  };
  const amountOptions = useMemo(() => {
    if (actionType === 'deposit')
      return [
        { key: '20', value: 20 },
        { key: '50', value: 50 },
        {
          key: '100',
          value: 100,
        },
        { key: 'MAX', value: 50000 },
      ];

    return [
      ...hotMoney((balance * (1-calcWithdrawFee))),
      { key: (balance * (1-calcWithdrawFee)).toFixed(2), value: (balance * (1 - calcWithdrawFee)) },
    ];
  }, [actionType, balance]);
  const fullAmountRef = useRef();
  return (
    <Ratio aspectRatio={3 / 5.2}>
      <div
        className={classNames(classes.container, classes[platform])}
        style={{ backgroundColor: platform === 'web' ? '#F1F1F1' : color }}
        {...props}
      >
        <button
          className={classes.close}
          onClick={(e) => {
            e.stopPropagation();
            clearTimeout(resendTimeoutRef.current);

            /*if (actionState.confirm) {
              setActionState({
                show: true,
                confirm: false,
                resend: false,
                error: {},
                data: {},
              });
            } else */
            if (deleteState.show) {
              setDeleteState({ show: false, error: '' });
            } else {
              onDelete({
                action: 'sms',
                cardId: id,
                provider: provider,
                callback: (state) => {
                  //console.log(state);
                  setActionState({
                    show: true,
                    confirm: false,
                    error: {},
                    data: {},
                  });
                  setDeleteState({ show: true, error: '' });
                  if (state?.left) {
                    resendTimeoutRef.current = setTimeout(
                      () =>
                        setDeleteState((prevState) => ({
                          ...prevState,
                          resend: true,
                        })),
                      state?.left * 1000
                    );
                  }
                },
              });
            }
          }}
        >
          <Icon
            height={'1.5rem'}
            width={'1.5rem'}
            Icon={
              platform === 'web' || deleteState.show ? CloseDark : CloseLight
            }
          />
        </button>
        {/*--- delete card form ---*/}
        <CSSTransition
          in={deleteState.show}
          timeout={300}
          unmountOnExit
          classNames={{
            enter: classes.enter,
            enterActive: classes.enterActive,
            enterDone: classes.enterDone,
            exit: classes.exit,
            exitActive: classes.exitActive,
          }}
          nodeRef={deleteFormRef}
        >
          <Stack
            as={Form}
            gap={4}
            noValidate
            autoComplete={'off'}
            onSubmit={deleteHandler}
            onClick={(e) => e.stopPropagation()}
            className={classNames(classes.delete,{"form-submit":deleteState.show})}
            ref={deleteFormRef}
          >
            <Form.Group className={classes.formGroup}>
              <Form.Label
                style={{
                  color: deleteState.error ? 'var(--bs-danger)' : '',
                  textAlign: 'center',
                }}
              >
                {!deleteState.error
                  ? t('ბარათის წასაშლელად მიუთითეთ SMS კოდი')
                  : deleteState.error}
              </Form.Label>
              <div style={{ position: 'relative' }}>
                <Form.Control
                  ref={oneTimeCodeRef}
                  autoFocus
                  name={'sms'}
                  isInvalid={!!deleteState.error}
                  autoComplete={'one-time-code'}
                  /*onFocus={() => onMobInput()}
                  onBlur={() => onMobInput(false)}*/
                />
                {/*--- resend confirmation sms icon ---*/}
                {deleteState.resend && (
                  <Button
                    variant={'info'}
                    outline
                    type={'button'}
                    onClick={() => {
                      onDelete({
                        action: 'sms',
                        cardId: id,
                        provider: provider,
                        callback: (state) => {
                          //console.log(state);
                          setActionState({
                            show: true,
                            confirm: false,
                            error: {},
                            data: {},
                          });
                          setDeleteState({ show: true, error: '' });
                          if (state?.left) {
                            resendTimeoutRef.current = setTimeout(
                              () =>
                                setDeleteState((prevState) => ({
                                  ...prevState,
                                  resend: true,
                                })),
                              state?.left * 1000
                            );
                          }
                        },
                      });
                    }}
                    style={{
                      position: 'absolute',
                      right:
                        platform === 'mob' || !deleteState.error
                          ? '0.7rem'
                          : '2.5rem',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      width: 'fit-content',
                      border: 'none',
                      background: 'transparent',
                      padding: 0,
                    }}
                  >
                    <Icon
                      height={'2rem'}
                      width={'2rem'}
                      type={'vec'}
                      Icon={Resend}
                      style={{
                        backgroundColor: '#435fa0',
                      }}
                    />
                  </Button>
                )}
              </div>
            </Form.Group>
            <Button variant={'secondary'} type={'submit'}>
              {t('დასტური')}
            </Button>
          </Stack>
        </CSSTransition>
        <div
          className={classes.logo}
          style={{ backgroundImage: `url(${logo})` }}
        />
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '100%',
          }}
        >
          {/*--- action form ---*/}
          <CSSTransition
            in={actionState.show}
            timeout={300}
            unmountOnExit
            classNames={{
              enter: classes.enter,
              enterActive: classes.enterActive,
              enterDone: classes.enterDone,
              exit: classes.exit,
              exitActive: classes.exitActive,
            }}
            nodeRef={actionFormRef}
          >
            <Form
              className={classNames(classes.action, classes[platform],{"form-submit":actionState.confirm})}
              noValidate
              onSubmit={submitHandler}
              onClick={(e) => {
                e.stopPropagation();
              }}
              ref={actionFormRef}
              autoComplete={'off'}
            >
              <Row>
                <Col xs={7}>
                  {!actionState.confirm ? (
                    /*--- amount input ---*/
                    <div
                      className={classes.amountContainer}
                      tabIndex={0}
                      /*onFocus={() => onMobInput()}
                      onBlur={() => onMobInput(false)}*/
                    >
                      <div className={classes.popover}>
                        <div className={classes.border}>
                          {_.map(amountOptions, (v, k) => (
                            <button
                              key={k}
                              type={'button'}
                              className={
                                v.key !== 'MAX' ? classes.number : null
                              }
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                const parsedBalance = parseFloat(balance)
                                const newVal =
                                  actionType !== 'withdraw' ||
                                  v.value <= parsedBalance
                                    ? v.value
                                    : parsedBalance;

                                setActionState({
                                  ...actionState,
                                  data: {
                                    ...actionState.data,
                                    amount: newVal.toFixed(2),
                                  },
                                  error: { ...actionState.error, amount: '' },
                                });
                                if (
                                  actionType === 'withdraw' &&
                                  fullAmountRef.current
                                )
                                  fullAmountRef.current.value = (
                                      newVal/ (1 - calcWithdrawFee)
                                  ).toFixed(2);


                                //e.target.blur();
                              }}
                            >
                              {v.key}
                            </button>
                          ))}
                        </div>
                      </div>
                      <Form.Group className={classes.formGroup}>
                        {!!actionState.error.amount && (
                          <Form.Label>{actionState.error.amount}</Form.Label>
                        )}
                        <FloatingLabel
                          label={t('თანხა')}
                          style={{
                            color: !actionState.error.amount
                              ? '#8e8e8e'
                              : 'var(--bs-danger)',
                          }}
                          className={classes.floatingLabel}
                        >
                          <Form.Control
                            placeholder={t('თანხა')}
                            type={'number'}
                            name={'amount'}
                            value={actionState.data.amount}
                            onChange={(e) => {
                              const formattedVal =
                                e.target.value.split('.')[1]?.length > 2
                                  ? parseFloat(e.target.value).toFixed(2)
                                  : e.target.value;
                              const limit =
                                actionType === 'withdraw'
                                  ? (balance * (1-calcWithdrawFee))
                                  : 50000;
                              const newVal =
                                parseFloat(formattedVal) > limit
                                  ? limit.toFixed(2)
                                  : formattedVal;
                              setActionState({
                                ...actionState,
                                data: {
                                  ...actionState.data,
                                  amount: newVal,
                                },
                                error: { ...actionState.error, amount: '' },
                              });
                              if (fullAmountRef.current){
                                const parsedNewAmount = parseFloat(newVal);
                                fullAmountRef.current.value = (
                                    parsedNewAmount/ (1 - calcWithdrawFee)
                                ).toFixed(2);
                              }

                            }}
                            isInvalid={!!actionState.error.amount}
                            style={{
                              borderColor: !!actionState.error.amount
                                ? 'var(--bs-danger)'
                                : '#fff',
                            }}
                          />
                        </FloatingLabel>
                      </Form.Group>
                    </div>
                  ) : (
                    /*--- sms input ---*/
                    <Form.Group className={classes.formGroup}>
                      {!!actionState.error.sms && (
                        <Form.Label>{actionState.error.sms}</Form.Label>
                      )}
                      <FloatingLabel
                        label={'SMS'}
                        autoFocus
                        style={{
                          color: !actionState.error.sms
                            ? '#8e8e8e'
                            : 'var(--bs-danger)',
                        }}
                        className={classes.floatingLabel}
                      >
                        <Form.Control

                          ref={oneTimeCodeRef}
                          placeholder={'SMS'}
                          type={'text'}
                          name={'sms'}
                          autoFocus
                          autoComplete={'one-time-code'}
                          onChange={(e) =>
                            setActionState({
                              ...actionState,
                              data: {
                                ...actionState.data,
                                sms: e.target.value,
                              },
                              error: { ...actionState.error, sms: '' },
                            })
                          }
                          value={actionState.data.sms}
                          isInvalid={!!actionState.error.sms}
                          style={{
                            borderColor: !!actionState.error.sms
                              ? 'var(--bs-danger)'
                              : '#fff',
                            paddingRight: !actionState.error.sms
                              ? '3rem'
                              : '4.5rem',
                          }}
                        />
                        {/*resend confirmation sms icon*/}
                        {actionState.resend && (
                          <Button
                            variant={'info'}
                            outline
                            type={'button'}
                            onClick={(event) => {

                              clearTimeout(resendTimeoutRef.current);
                              setActionState((prevState) => ({
                                ...prevState,
                                resend: false,
                                data: { ...prevState.data, sms: '' },
                                error: { ...prevState.error, sms: '' },
                              }));
                              submit(
                                {
                                  cardId: id,
                                  amount: parseFloat(actionState.data.amount),
                                  sms: parseInt(''),
                                  provider: provider,
                                  confirm: false,
                                  loader: setLoader,
                                },
                                ({ left, ...callback }) => {
                                  oneTimeCodeRef.current.value="";
                                  oneTimeCodeRef.current.focus()
                                  if (left) {
                                    resendTimeoutRef.current = setTimeout(
                                      () =>
                                        setActionState((prevState) => ({
                                          ...prevState,
                                          resend: true,
                                        })),
                                      left * 1000
                                    );
                                  }
                                  setActionState((prevState) => ({
                                    ...prevState,
                                    ...callback,
                                  }));
                                }
                              );
                            }}
                            style={{
                              position: 'absolute',
                              right:
                                platform === 'mob' || !actionState.error.sms
                                  ? '0.7rem'
                                  : '2.5rem',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              width: 'fit-content',
                              border: 'none',
                              background: 'transparent',
                              padding: 0,
                            }}
                          >
                            <Icon
                              height={'2rem'}
                              width={'2rem'}
                              type={'vec'}
                              Icon={Resend}
                              style={{
                                backgroundColor: '#435fa0',
                              }}
                            />
                          </Button>
                        )}
                      </FloatingLabel>
                    </Form.Group>
                  )}
                </Col>
                <Col
                  xs={'auto'}
                  style={{ display: 'flex', alignItems: 'flex-end' }}
                >
                  <Button
                    variant={
                      platform === 'mob' || actionState.confirm
                        ? 'secondary'
                        : 'success'
                    }
                    style={
                      actionState.confirm && {
                        backgroundColor: '#435FA0',
                        borderColor: '#435FA0',
                        color: '#fff',
                      }
                    }
                    disabled={loader}
                    type={'submit'}
                  >
                    <Loader loader={loader} />

                    <span>
                      {actionState.confirm
                        ? t('დასტური')
                        : actionType === 'deposit'
                        ? t('შევსება')
                        : t('გატანა')}
                    </span>
                  </Button>
                </Col>

                {actionType === 'withdraw' &&
                  !actionState.confirm &&
                  actionState.data.amount?.trim()?.length > 0 && (
                    <Col xs={12} className={classes.fullAmountContainer}>
                      <div style={{ marginTop: '1rem' }}>
                        <span>{t('საკომისიო')}</span>
                        <span style={{ fontWeight: 'bold' }}>
                          {withdrawFee}% (
                          {(parseFloat(actionState.data.amount) / (1-calcWithdrawFee) * (calcWithdrawFee)).toFixed(
                            2
                          )}
                          )
                        </span>
                      </div>
                      <div>
                        <span>{t("ანგარიშიდან ჩამოგეჭრებათ")} </span>
                        {/*<span style={{ fontWeight: 'bold' }}>
                      {(parseFloat(actionState.data.amount) * 1.03).toFixed(2)}
                    </span>*/}
                        <Form.Control
                          ref={fullAmountRef}
                          name={'fullAmount'}
                          defaultValue={(
                              actionState.data.amount * (1 + calcWithdrawFee)
                          ).toFixed(2)}
                          onChange={(e) => {

                            const formattedVal =
                              e.target.value.split('.')[1]?.length > 2
                                ? parseFloat(e.target.value).toFixed(2)
                                : e.target.value;
                            fullAmountRef.current.value =
                              parseFloat(formattedVal) > parseFloat(balance)
                                ? balance
                                : formattedVal;
                            setActionState({
                              ...actionState,
                              data: {
                                ...actionState.data,
                                amount:
                                  parseFloat(e.target.value) > balance
                                    ? (balance * (1-calcWithdrawFee)).toFixed(2)
                                    : ((e.target.value || 0) * (1- calcWithdrawFee)).toFixed(2),
                              },
                              error: { ...actionState.error, amount: '' },
                            });
                          }}
                        />
                      </div>
                    </Col>
                  )}
              </Row>
            </Form>
          </CSSTransition>
        </div>
        <Stack
          className={classes.number}
          direction={'horizontal'}
          gap={3}
          style={{ backgroundColor: color }}
        >
          {_.map(digits, (v, k) => {
            return (
              <div
                key={k}
                className={`${k === digits.length - 1 ? classes.visible : ''}`}
              >{v}
              </div>
            );
          })}
        </Stack>
      </div>
    </Ratio>
  );
};

export default Card;
